define('viewmodels/pages/games/all',[], function () {

    var AllGames = function(gamesBrowser, tabs, getField) {
        this.allGamesCategory = gamesBrowser.getCategoryById('all');
        this.meta = {
            title: getField('meta_title'),
            description: getField('meta_description')
        };
        this.subNav = tabs;
    };

    return AllGames;
});

